import { toast } from "@jsq/ds/core";
import { ProgramType } from "~/graphql/supergraphEnums";
import { useSetClientProgramMutation } from "~/graphql/supergraphHooks";
import { ApplyProgramOutcome, SingleProgramTab } from "../SingleProgramTab";
import { SettingsDrawerTabProps } from "../types";

export const ClientProgramTab = (props: SettingsDrawerTabProps) => {
  const { row } = props;

  const [setClientProgram] = useSetClientProgramMutation({
    onError: (e) => toast.error(e.message),
  });

  const applyProgram = async (programType: ProgramType): Promise<ApplyProgramOutcome> => {
    const result = await setClientProgram({
      variables: { arenaId: Number(row.arenaId), programType },
    });
    if (result.data?.setClientProgram?.ok) return "saved";
    return result.data?.setClientProgram ? "rejected" : "errored";
  };

  return (
    <SingleProgramTab
      {...props}
      subject="client"
      programLabel="Client AML/KYC compliance program"
      description={`Configure the compliance program that ${row.name} must comply with when onboarding on to the Juniper Square platform.`}
      assignedProgram={row.clientProgram}
      successToast={`${row.name} client program has been updated`}
      applyProgram={applyProgram}
    />
  );
};
